import { useAuth } from "hooks/auth";
import { querystring } from "models/Listing";
import useSWR from "swr";
import { Nullable } from "types/global";
import { ListingProps } from "types/listing";
import { OLDate } from "utilities/dateFormat";
import { getEnvVariable } from "utilities/env";

export function useLogs() {
  const { fetcher } = useAuth();
  const useLogsList = (props?: ListingProps) => {
    return useSWR(
      () =>
        `${getEnvVariable("REACT_APP_API_URL")}/audit/log${querystring(props)}`,
      fetcher,
    );
  };
  const exportLogs = async (
    createdAtFrom?: Nullable<string>,
    createdAtTo?: Nullable<string>,
  ) => {
    const response = await fetcher(
      `${getEnvVariable("REACT_APP_API_URL")}/audit/log/export${
        createdAtFrom && createdAtTo
          ? `?createdAt[gt]=${createdAtFrom}&createdAt[lt]=${createdAtTo}`
          : ""
      }`,
    );

    const data = await response.blob();
    const url = URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `audit-log-export-${OLDate(new Date(), {
        formatString: "yyyy-MM-dd",
      })}.csv`,
    );
    document.body.appendChild(link);
    link.click();
  };
  return {
    exportLogs,
    useLogsList,
  };
}
